import { Reducer } from 'redux';
import { CollaboratorsState, CollaboratorsTypes } from './types';

export const INITIAL_STATE: CollaboratorsState = {
  collaboratorsList: [],
  collaboratorData: {
    id: '',
    name: '',
    email: '',
    phone: '',
    document: '',
    photoUrl: '',
    createdAt: '',
    updatedAt: '',
    UserDocuments: [],
  },
  linkCollaboratorCompanyData: '',
  unlinkCollaboratorCompanyData: '',
  totalCount: 0,
  loading: false,
  error: false,
};

const reducer: Reducer<CollaboratorsState> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    // LIST COLLABORATORS
    case CollaboratorsTypes.LIST_COLLABORATORS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        collaboratorsList: INITIAL_STATE.collaboratorsList,
      };
    case CollaboratorsTypes.LIST_COLLABORATORS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        collaboratorsList: action.payload.collaboratorsList,
        totalCount: action.payload.totalCount,
      };
    case CollaboratorsTypes.LIST_COLLABORATORS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        collaboratorsList: INITIAL_STATE.collaboratorsList,
      };
    // GET COLLABORATOR
    case CollaboratorsTypes.GET_COLLABORATOR_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        collaboratorData: INITIAL_STATE.collaboratorData,
      };
    case CollaboratorsTypes.GET_COLLABORATOR_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        collaboratorData: action.payload.collaboratorData,
      };
    case CollaboratorsTypes.GET_COLLABORATOR_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        collaboratorData: INITIAL_STATE.collaboratorData,
      };
    // FILTER COLLABORATORS
    case CollaboratorsTypes.FILTER_COLLABORATORS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        collaboratorsList: INITIAL_STATE.collaboratorsList,
      };
    case CollaboratorsTypes.FILTER_COLLABORATORS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        collaboratorsList: action.payload.collaboratorsList,
        totalCount: action.payload.totalCount,
      };
    case CollaboratorsTypes.FILTER_COLLABORATORS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        collaboratorsList: INITIAL_STATE.collaboratorsList,
      };
    // LINK COLLABORATOR TO COMPANY
    case CollaboratorsTypes.LINK_COLLABORATOR_TO_COMPANY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        linkCollaboratorCompanyData: INITIAL_STATE.linkCollaboratorCompanyData,
      };
    case CollaboratorsTypes.LINK_COLLABORATOR_TO_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        linkCollaboratorCompanyData: action.payload.linkCollaboratorCompanyData,
      };
    case CollaboratorsTypes.LINK_COLLABORATOR_TO_COMPANY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        linkCollaboratorCompanyData: INITIAL_STATE.linkCollaboratorCompanyData,
      };

    // UNLINK COLLABORATOR FROM COMPANY
    case CollaboratorsTypes.UNLINK_COLLABORATOR_FROM_COMPANY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        unlinkCollaboratorCompanyData:
          INITIAL_STATE.unlinkCollaboratorCompanyData,
      };
    case CollaboratorsTypes.UNLINK_COLLABORATOR_FROM_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        unlinkCollaboratorCompanyData:
          action.payload.unlinkCollaboratorCompanyData,
      };
    case CollaboratorsTypes.UNLINK_COLLABORATOR_FROM_COMPANY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        unlinkCollaboratorCompanyData:
          INITIAL_STATE.unlinkCollaboratorCompanyData,
      };

    // CREATE COLLABORATOR
    case CollaboratorsTypes.CREATE_COLLABORATOR_REQUEST:
      return { ...state, loading: true, error: false };
    case CollaboratorsTypes.CREATE_COLLABORATOR_SUCCESS:
      return { ...state, loading: false, error: false };
    case CollaboratorsTypes.CREATE_COLLABORATOR_FAILURE:
      return { ...state, loading: false, error: true };
    // UPDATE COLLABORATOR
    case CollaboratorsTypes.UPDATE_COLLABORATOR_REQUEST:
      return { ...state, loading: true, error: false };
    case CollaboratorsTypes.UPDATE_COLLABORATOR_SUCCESS:
      return { ...state, loading: false, error: false };
    case CollaboratorsTypes.UPDATE_COLLABORATOR_FAILURE:
      return { ...state, loading: false, error: true };
    // DELETE COLLABORATOR
    case CollaboratorsTypes.DELETE_COLLABORATOR_REQUEST:
      return { ...state, loading: true, error: false };
    case CollaboratorsTypes.DELETE_COLLABORATOR_SUCCESS:
      return { ...state, loading: false, error: false };
    case CollaboratorsTypes.DELETE_COLLABORATOR_FAILURE:
      return { ...state, loading: false, error: true };
    // CREATE COLLABORATORS
    case CollaboratorsTypes.CREATE_COLLABORATORS_REQUEST:
      return { ...state, loading: true, error: false };
    case CollaboratorsTypes.CREATE_COLLABORATORS_SUCCESS:
      return { ...state, loading: false, error: false };
    case CollaboratorsTypes.CREATE_COLLABORATORS_FAILURE:
      return { ...state, loading: false, error: true };
    // UPDATE COLLABORATORS
    case CollaboratorsTypes.UPDATE_COLLABORATORS_REQUEST:
      return { ...state, loading: true, error: false };
    case CollaboratorsTypes.UPDATE_COLLABORATORS_SUCCESS:
      return { ...state, loading: false, error: false };
    case CollaboratorsTypes.UPDATE_COLLABORATORS_FAILURE:
      return { ...state, loading: false, error: true };
    // DELETE COLLABORATORS
    case CollaboratorsTypes.DELETE_COLLABORATORS_REQUEST:
      return { ...state, loading: true, error: false };
    case CollaboratorsTypes.DELETE_COLLABORATORS_SUCCESS:
      return { ...state, loading: false, error: false };
    case CollaboratorsTypes.DELETE_COLLABORATORS_FAILURE:
      return { ...state, loading: false, error: true };
    default:
      return state;
  }
};

export default reducer;
